import { makeStyles } from '@material-ui/core'

import { lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: 'grid',
    alignItems: 'center',
    gap: 5,
    paddingLeft: 12,
    backgroundColor: theme.palette.background.default,
    textAlign: 'left',
    height: '12vh',
    overflowY: 'auto',
    gridTemplateColumns:
      '0.8fr 0.4fr 1fr 1.2fr 1.2fr 1fr 0.6fr 1fr 1fr 1fr 0.2fr',
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: '1fr 0.6fr 1fr 1.2fr 1.4fr 1fr 1.3fr 1.3fr 0.1fr'
    }
  },
  tableRowOdd: {
    backgroundColor: theme.palette.grey[200]
  },
  skeleton: {
    marginTop: '14px!important',
    marginBottom: '14px!important',
    width: '80%'
  },
  cursor: {
    cursor: 'pointer'
  },
  textFont: {
    fontSize: lang === 'en' ? '12.5px' : '11px',
    lineBreak: 'anywhere',
    [theme.breakpoints.up(1680)]: {
      fontSize: lang === 'en' ? '13px' : '12px',
      lineBreak: 'anywhere'
    },
    textAlign: 'center'
  },
  cell: { display: 'flex', justifyContent: 'center' },
  textFontFirstElement: {
    fontSize: lang === 'en' ? '12.5px' : '11px',
    lineBreak: 'anywhere',
    [theme.breakpoints.up(1680)]: {
      fontSize: lang === 'en' ? '13px' : '12px',
      lineBreak: 'anywhere'
    }
  }
}))
export default useStyles
